import { FC, PropsWithChildren } from "react";
import { Spinner } from "react-bootstrap";

export const LoadingWrapper: FC<PropsWithChildren<{ isLoading: boolean }>> = ({ isLoading, children }) => {
  return isLoading ? <Spinner animation="border" /> : <>{children}</>;
};
